import styled, { css } from "styled-components";

import { space, varColor } from "@formant/ui/utils/themeHelpers";

const [width, height] = [9 / 4, 11 / 8];
const dotSize = 1;
const [railWidth, railHeight] = [width * (5 / 6), 9 / 16];

export const Rail = styled.div`
    position: absolute;
    left: ${((width - railWidth) / 2).toFixed(2)}rem;
    top: ${((height - railHeight) / 2).toFixed(2)}rem;
    background: ${varColor("primary", "steel02")};
    border-radius: ${(railHeight / 2).toFixed(2)}rem;
    height: ${railHeight}rem;
    width: ${railWidth}rem;
`;

const createTransition =
    (timing: string, method: string = "ease-in-out", delay = "0ms") =>
    (...properties: string[]) =>
        properties.map(it => `${it} ${timing} ${method} ${delay}`).join(",");

const fastTransitionFor = createTransition("75ms", "ease-in-out");
const defaultTransitionFor = createTransition("200ms", "ease-in-out");

export const Handle = styled.div`
    border-radius: ${dotSize / 2}rem;
    height: ${dotSize}rem;
    position: absolute;
    top: ${((height - dotSize) / 2).toFixed(2)}rem;
    transition: ${defaultTransitionFor(
        "left",
        "background-color",
        "box-shadow",
    )};
    width: ${dotSize}rem;
`;

const HandleOn = css`
    left: ${(width - dotSize).toFixed(2)}rem;
    background: ${varColor("highlights", "blue")};
`;

const HandleOff = css`
    left: 0;
    background: ${varColor("primary", "silver")};
`;

export const Switch = styled.div`
    position: relative;
    height: ${height}rem;
    width: ${width}rem;

    &:not(:last-child) {
        margin-right: 1ch;
    }
`;

export const Label = styled.span`
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.06875rem;
    line-height: 180%;
    margin: 0 ${space(10)} 0 0;
    text-transform: uppercase;
    transition: ${defaultTransitionFor("color")};
`;

export const Container = styled.button<{ $on: boolean }>`
    align-items: center;
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    font: inherit;
    margin: 1ch;
    padding: ${space(2)} ${space(5)};
    outline-offset: 1px;
    outline: 1px dotted transparent;
    transition: ${fastTransitionFor("outline")};

    &:focus {
        outline: 1px dotted ${varColor("highlights", "blue")};
    }

    &:disabled ${Switch} {
        opacity: 0.5;
    }

    ${Handle} {
        ${({ $on: on }) => (on ? HandleOn : HandleOff)}
    }

    &:hover ${Handle} {
        box-shadow: 0 0 0 0.0625rem
            ${({ $on: on }) =>
                on
                    ? varColor("highlights", "blue")
                    : varColor("primary", "silver")};
    }

    &:hover,
    &:focus {
        ${Label} {
            color: white;
        }
    }
`;
